export const normalizeStatusValue = (status) => {
  if (typeof status === "string") {
    return status.trim();
  }

  if (status && typeof status === "object") {
    const value = status.value ?? status.label;
    return typeof value === "string" ? value.trim() : "";
  }

  return "";
};
